import { RootState } from '../../interfaces/rootState';

export const CaseQueueSelector = (state: RootState) => state.caseQueue;
